import React from "react";
import { Styles } from "./styles";
import Logo from "../../assets/images/logo.webp";
import { useSelector } from "react-redux";
import { t } from "i18next";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  return (
    <Styles>
      <div id="errorPage">
        <div className="error-page-data">
          <div className="logo">
            <img src={Logo} alt="logo" />
          </div>
          <div class="error-404">
            <h1>
              {Resource?.unfortunately
                ? Resource?.unfortunately
                : t("unfortunately")}
              !
            </h1>
          </div>
          <h2>
            {Resource?.page_not_found
              ? Resource?.page_not_found
              : t("page_not_found")}
          </h2>
          <p>
            {Resource?.page_not_fount_details
              ? Resource?.page_not_fount_details
              : t("page_not_fount_details")}
          </p>
          <Link to="/">
            {Resource?.go_to_home_page
              ? Resource?.go_to_home_page
              : t("go_to_home_page")}
          </Link>
        </div>
      </div>
    </Styles>
  );
};

export default ErrorPage;
